module.exports = __webpack_public_path__ + "img/sx.7c3bd71b.svg";